import {useEffect, useState} from 'react';

import {clockTime} from '../format';

/**
 * A live elapsed-time counter.
 *
 * Used wherever the design shows generation progress. A synchronous provider call
 * reports no progress, so there is no honest percentage to show — elapsed time is real
 * information and a fabricated "62%" is not.
 */
export function Elapsed() {
  const [start] = useState(() => Date.now());
  const [now, setNow] = useState(start);

  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 500);
    return () => clearInterval(timer);
  }, []);

  return (
    <span className="mono" dir="ltr">
      {clockTime((now - start) / 1000)}
    </span>
  );
}

export function Skeleton({width = '100%', height = 13}: {width?: string; height?: number}) {
  return <div className="sk shimmer" style={{width, height}} />;
}
